<div
  *ngIf="totalRecords > RowsPerPageOptions[0] && !isLoading"
  [class]="
    'flex justify-around md:justify-between px-6 py-2 bg-white ' + stylesClass
  "
>
  <!-- ROW PAGINATION -->
  <div class="max-md:hidden flex items-center gap-2">
    <span class="text-sm">
      {{ "common.rows-per-page" | translate | sentenceCase }}:
    </span>
    <p-dropdown
      (ngModelChange)="onRowsChange($event)"
      [ngModel]="pagination.rows"
      [options]="RowsPerPageOptions"
      appendTo="body"
      styleClass="h-9 flex items-center"
    ></p-dropdown>
  </div>
  <!-- PAGE PAGINATION -->
  <div class="flex items-center gap-2">
    <span *ngIf="!isCompact" class="max-lg:hidden text-sm">
      {{ pagination.rows * pagination.page + 1 }} -
      {{ pagination.rows * pagination.page + dataLength }}
      {{ "common.of" | translate }}
      {{ totalRecords }}
    </span>
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="pagination.rows * pagination.page"
      [rows]="pagination.rows"
      [totalRecords]="totalRecords"
    ></p-paginator>
  </div>
</div>
